import type { IconContainerProps } from './typings'

import { IconContainer } from './elements/IconContainer'

export function Handshake(props: IconContainerProps) {
  return (
    <IconContainer {...props}>
      <svg viewBox="0 0 48 48">
        <path
          d="M34.2 29.488C34.4235 29.9093 34.489 30.3966 34.3849 30.8619C34.2807 31.3273 34.0137 31.7401 33.632 32.026L31.82 33.38L31 34L27 36H18.108C17.7681 36.0007 17.4337 35.9147 17.1362 35.7503C16.8388 35.5858 16.5881 35.3482 16.408 35.06L12 28H7V14H26L33 25L33.41 28L34.2 29.488Z"
          fill="#D4E3F3"
        />
        <path
          d="M8 12H4C3.44772 12 3 12.4477 3 13V31C3 31.5523 3.44772 32 4 32H8C8.55228 32 9 31.5523 9 31V13C9 12.4477 8.55228 12 8 12Z"
          fill="#4383CC"
        />
        <path
          d="M23.12 36.0005H20.89L18.11 30.4505C18.013 30.2174 18.0077 29.9562 18.0952 29.7194C18.1828 29.4826 18.3567 29.2876 18.582 29.1737C18.8073 29.0597 19.0674 29.0353 19.31 29.1052C19.5527 29.1751 19.7599 29.3342 19.89 29.5505L23.12 36.0005ZM27.9 35.5505L27 36.0005H25.91L23.08 29.3905C23.0228 29.2687 22.9906 29.1366 22.9856 29.0021C22.9806 28.8677 23.0028 28.7335 23.0508 28.6078C23.0989 28.4821 23.1718 28.3674 23.2653 28.2705C23.3587 28.1737 23.4707 28.0967 23.5946 28.0442C23.7185 27.9916 23.8518 27.9647 23.9864 27.9648C24.1209 27.965 24.2541 27.9924 24.3779 28.0453C24.5016 28.0982 24.6134 28.1755 24.7066 28.2726C24.7998 28.3697 24.8724 28.4847 24.92 28.6105L27.9 35.5505ZM31.82 33.3805L31 34.0005L30.1 34.4505L27.08 27.3905C27.0228 27.2687 26.9906 27.1366 26.9856 27.0021C26.9806 26.8677 27.0028 26.7335 27.0508 26.6078C27.0989 26.4821 27.1718 26.3674 27.2653 26.2705C27.3587 26.1737 27.4707 26.0967 27.5946 26.0442C27.7185 25.9916 27.8518 25.9647 27.9864 25.9648C28.1209 25.965 28.2541 25.9924 28.3779 26.0453C28.5016 26.0982 28.6134 26.1755 28.7066 26.2726C28.7998 26.3697 28.8724 26.4847 28.92 26.6105L31.82 33.3805Z"
          fill="#A1C1E6"
        />
        <path
          d="M39 16L32.461 12.264C32.1589 12.0912 31.817 12.0002 31.469 12H22.908C22.6228 11.9999 22.3409 12.0608 22.0811 12.1786C21.8214 12.2964 21.5898 12.4684 21.402 12.683L15 20L16.17 21.17C16.5415 21.5419 16.9826 21.8369 17.4682 22.0382C17.9538 22.2395 18.4743 22.3431 19 22.3431C19.5257 22.3431 20.0462 22.2395 20.5318 22.0382C21.0174 21.8369 21.4585 21.5419 21.83 21.17L25 18L29 20L33.36 28H41V16H39Z"
          fill="#A1C1E6"
        />
        <path
          d="M44 12H40C39.4477 12 39 12.4477 39 13V31C39 31.5523 39.4477 32 40 32H44C44.5523 32 45 31.5523 45 31V13C45 12.4477 44.5523 12 44 12Z"
          fill="#0E4686"
        />
      </svg>
    </IconContainer>
  )
}
